export default __webpack_public_path__ + "static/media/register.943621fa.jpeg";